import { api } from './http';

export type SenderConsoleSummary = {
	status: 'running' | 'stopped' | 'idle';
	accountsTotal: number;
	accountsProcessed: number;
	messagesSent: number;
	messagesSuccess: number;
	messagesErrors: number;
	byPreset: {
		presetId: string | null;
		name: string;
		accounts: number;
		messages: number;
		errors: number;
	}[];
	byBuild: {
		buildId: string;
		dialogs: number;
		spammed: number;
	}[];
};

export type SenderConsoleEvent = {
	id: string;
	at: string;
	runId: string | null;
	sessionLabel: string | null;
	presetName: string | null;
	phase: string | null;
	message: string;
	level: 'info' | 'error';
};

export async function fetchSenderConsoleSummary(params?: { period?: string }) {
	const { data } = await api.get<SenderConsoleSummary>('/sender/console/summary', { params });
	return data;
}

export async function fetchSenderConsoleEvents(params?: {
	cursor?: string;
	limit?: number;
	q?: string;
}) {
	const { data } = await api.get<{ items: SenderConsoleEvent[]; nextCursor: string | null }>(
		'/sender/console/events',
		{ params },
	);
	return data;
}
